import React, { useEffect } from "react";
import { Box, Grid, Card, Typography } from "@mui/joy";
import { CardContent } from "@mui/material";
import { LoadingView, PageTitle } from "../../../components";
import FolderIcon from "@mui/icons-material/Folder";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { listLogsRequest, listLogsReset } from "../../../store/actions";
import { STATUS } from "../../../constant";
import { toast } from "react-toastify";

const LOG_CATEGORIES = [
  "error_logs",
  "response_logs",
  "success_logs",
  "failure_logs",
];

const ListLogs = ({
  otpResult,
  listLogsStatus,
  listLogsMessage,
  listLogsResult,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = otpResult?.token;

  useEffect(() => {
    dispatch(listLogsRequest(token, []));
  }, []);

  useEffect(() => {
    if (listLogsStatus === STATUS.ERROR) {
      toast.error(listLogsMessage, {
        toastId: "listLogsError",
      });
      dispatch(listLogsReset());
    }
  }, [dispatch, listLogsMessage, listLogsStatus]);

  return (
    <>
      <LoadingView loading={listLogsStatus === STATUS.LOADING} />
      <Box>
        <PageTitle title={"System Logs"} />

        {LOG_CATEGORIES.map((category) => {
          const dates = listLogsResult?.[category];
          if (!dates || dates.length === 0) return null;

          return (
            <Box key={category} sx={{ mb: 3 }}>
              <Typography
                level="title-md"
                sx={{ mb: 1, textTransform: "capitalize" }}
              >
                {category.replace(/_/g, " ")}
              </Typography>
              <Grid
                container
                spacing={{ xs: 1, md: 2 }}
                columns={{ xs: 10, sm: 10, md: 10 }}
              >
                {dates.map((date, index) => (
                  <Grid xs={2} sm={2} md={2} key={index}>
                    <Card
                      variant="soft"
                      onClick={() =>
                        navigate("/list-folder-logs", {
                          state: {
                            folder_type: category,
                            folder_name: date,
                          },
                        })
                      }
                      sx={{
                        backgroundColor: "background.popup",
                        boxShadow: "sm",
                        p: 0,
                        cursor: "pointer",
                        minHeight: "80px",
                      }}
                    >
                      <CardContent>
                        <Box sx={{ display: "flex", gap: 1 }}>
                          <Card
                            variant="soft"
                            sx={{
                              backgroundColor: "#e3f2fd",
                              width: "45px",
                              height: "45px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              borderRadius: "8px",
                            }}
                          >
                            <FolderIcon
                              sx={{
                                color: "#1976d2",
                                fontSize: "22px",
                              }}
                            />
                          </Card>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                            }}
                          >
                            <Typography
                              level="body-sm"
                              sx={{ fontSize: "13px" }}
                            >
                              {date}
                            </Typography>
                          </Box>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Box>
          );
        })}
      </Box>
    </>
  );
};

const mapStateToProps = ({ auth, logs }) => {
  const { otpResult } = auth;
  const { listLogsStatus, listLogsMessage, listLogsResult } = logs;

  return {
    otpResult,
    listLogsStatus,
    listLogsMessage,
    listLogsResult,
  };
};

export default connect(mapStateToProps, {})(ListLogs);
